"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StarOutlineIcon = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _designTokens = require("@smartsheet/design-tokens");
var _react = _interopRequireWildcard(require("react"));
var _Icon = require("../../components/icon/Icon");
var _getUrsaIconColorVarName = require("../../components/icon/getUrsaIconColorVarName");
var _StarOutlineIcon = _interopRequireDefault(require("./StarOutlineIcon20"));
var _StarOutlineIcon2 = _interopRequireDefault(require("./StarOutlineIcon24"));
/**
 * This file is generated from scripts/genIconComponents.ts. Any
 * changes should be made in that file.
 */

const sizeMap = {
  20: /*#__PURE__*/_react.default.createElement(_StarOutlineIcon.default, null),
  24: /*#__PURE__*/_react.default.createElement(_StarOutlineIcon2.default, null)
};
const StarOutlineIcon = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    // This is the default icon color.
    color = `var(${(0, _getUrsaIconColorVarName.getUrsaIconColorVarName)()}, ${_designTokens.ursaColors.neutral800})`,
    size,
    style,
    ...rest
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Icon.Icon, (0, _extends2.default)({
    color: color,
    ref: ref,
    size: size
  }, rest, {
    style: {
      ...style
    }
  }), sizeMap[size]);
});
exports.StarOutlineIcon = StarOutlineIcon;
StarOutlineIcon.displayName = "StarOutlineIcon";
//# sourceMappingURL=StarOutlineIcon.js.map